import React from 'react';

import { PaymentStatusViewProps } from 'types';

import { DefaultPaymentReceiptsDispute } from '../DefaultPaymentReceiptsDispute';
import { DefaultPaymentStatusLayout } from '../DefaultPaymentStatusLayout';

export const DefaultPaymentStatus: React.FC<PaymentStatusViewProps> = ({
  actions,
  canManageReceipts,
}) => (
  <DefaultPaymentStatusLayout actions={actions}>
    {canManageReceipts && <DefaultPaymentReceiptsDispute />}
  </DefaultPaymentStatusLayout>
);
